import { Ring } from '@uiball/loaders'
import CheckIcon from 'assets/icons/step-done-check.svg?component'
import InfoBlock from 'components/UI/Blocks/InfoBlock'
import Typography from 'components/UI/Typography'
import { type GetWsStepStatus, type GetWsStepStatuses, FLOW_STEPS } from 'share/types'
import tw, { type TwStyle } from 'twin.macro'

export interface FlowStepType {
  id: string | number
  stepsName?: string
  status: GetWsStepStatus | GetWsStepStatuses
  apiSteps: FLOW_STEPS[]
  title?: string | null
  subtitle?: string | null
}

interface FlowStepsListProps {
  twStyle?: TwStyle | TwStyle[]
  steps: FlowStepType[]
  isDoneCondition?: (step: FlowStepType, index: number) => boolean
  isInProgressCondition?: (step: FlowStepType, index: number) => boolean
}

const FlowStepsList = ({ twStyle, steps, isDoneCondition, isInProgressCondition }: FlowStepsListProps) => {
  return (
    <InfoBlock twStyle={twStyle}>
      <ul tw='space-y-6'>
        {steps.map((step, idx) => (
          <li tw='flex items-center space-x-4' key={step.id}>
            {step.status === 'DONE' || isDoneCondition?.(step, idx) ? (
              <span tw='flex-shrink-0'>
                <CheckIcon tw='w-6 h-6' />
              </span>
            ) : step.status === 'IN_PROGRESS' || isInProgressCondition?.(step, idx) ? (
              <span tw='flex-shrink-0'>
                <Ring color='var(--primary-color)' size={24} />
              </span>
            ) : (
              <span tw='w-6 flex-shrink-0 text-center'>
                <Typography weight='bold'>{idx + 1}</Typography>
              </span>
            )}
            <div>
              <Typography variant='subbody'>{step.title}</Typography>
              <Typography variant='caption' twStyle={tw`text-grey-dark`}>
                {step.subtitle}
              </Typography>
            </div>
          </li>
        ))}
      </ul>
    </InfoBlock>
  )
}

export default FlowStepsList
